import React from 'react';
import {
    Container,
} from '@mui/material';


export const TermsOfUse = () => {

    return (
        <Container>
           Terms of use
        </Container>
    );
};
